<div class="main-content">
  <div class="headerFlexWrapper">
    <!-- <div class="left-set">
        <h2 class="cmn-title">
          Dashboard
        </h2>
        <div class="cmn-sub-title">
          <ul>
            <li >
              <a > test</a>
              <span >
                breadcrump</span>
            </li>
            <li >
              <a > test</a>
              <span >
                breadcrump</span>
            </li>
          </ul>
          <h6 class="back"  >
            <img src="assets/images/icons/icon-back.svg" alt="Icon Back" />
            Back
          </h6>
        </div>
      </div> -->

    <div class="left-set">
      <h2 class="cmn-title">
        <!-- {{ breadcrumbs.length ? breadcrumbs[0]?.name : "Dashboard" }} -->
      </h2>
      <div class="cmn-sub-title">
        <ul>
          <li *ngFor="let breadcrumb of breadcrumbs; let i = index">
            <a
              [routerLink]="breadcrumb.path"
              *ngIf="i < breadcrumbs.length - 1"
              >{{ breadcrumb.name }}</a
            >
            <span *ngIf="i === breadcrumbs.length - 1">{{
              breadcrumb.name
            }}</span>
          </li>
        </ul>
        <h6 class="back" *ngIf="shouldShowBackButton()" (click)="goBack()">
          <img src="assets/images/icons/icon-back.svg" alt="Icon Back" />
          Back
        </h6>
      </div>
    </div>
    <section class="header-wrapper">
      <div class="right-set">
        <!-- <div class="branch-wrapper">
          <h3>Branch</h3>
          <form>
            <mat-form-field>
              <mat-select placeholder="Select Branch">
                <mat-option> branchName </mat-option>
              </mat-select>
            </mat-form-field>
          </form>
        </div> -->

        <div class="right-combo-wrapper">
          <!-- <div class="notification-wrapper">
            <div class="notification-box active">
              <img
                src="assets/images/icons/notification.svg"
                alt="Notification"
              />
            </div>
          </div> -->
          <div class="profile-wrapper">
            <button
              (click)="toggleDropdown($event)"
              [ngClass]="{ 'class-clicked': isDropdownOpen }"
            >
              <div class="profile-icon">
                <img src="{{ url }}" alt="Profile Photo" />
              </div>
              <div class="details">
                <h2>{{ userName }}</h2>
                <h3>{{ userRole }}</h3>
              </div>
            </button>
          </div>
          <div class="mobileCanvasWrapper" (click)="toggleChange()">
            <img src="../../../assets/images/icons/burger.svg" alt="" />
          </div>
        </div>
      </div>
      <div [ngClass]="{ show: isDropdownOpen }" class="profile-items" #dropdown>
        <ul>
          <!-- <li (click)="onMyProfile()">
            <img src="assets/images/icons/icon-user.svg" alt="User Icon" /> My
            Profile
          </li> -->
          <li class="logout" (click)="logout()">
            <img src="assets/images/icons/icon-logout.svg" alt="User Logout" />
            Logout
          </li>
        </ul>
      </div>
    </section>
  </div>
</div>
